<template>
  <div class="imgBox min-w-1400">
    <div class="imgBox1 min-w-1400">
      <div class="img1 max-w-1400">
        <!-- <p class="imgItem1">ข้อตกลงความเป็นส่วนตัว</p> -->
        <!-- <img :src="importedImg1" :alt="altText" class="imgItem1" /> -->
      </div>
    </div>
    <div class="imgBox2 min-w-1400">
      <div class="pricacy img2 max-w-1400">
        <!-- <h1>Cam kết bảo mật</h1> -->
        <!-- <div class="title-line"></div> -->
        <!-- <div class="textBox" style="white-space: pre-wrap">{{ text }}</div> -->
        <h2 class="topTit">นโยบายความเป็นส่วนตัว (Privacy Notice)</h2>
        <h2 class="oneTit">PHANCHET MOTOR COMPANY LIMITED</h2>
        <p class="toRight">ปรับปรุงล่าสุดเมื่อ 25 เมษายน 2568</p>
        <p>
          บริษัท พันเชษฐ์ มอเตอร์ จำกัด (“บริษัท” หรือ “เรา”)
          ให้ความสำคัญกับความเป็นส่วนตัวของคุณเป็นอย่างยิ่ง
          เอกสารนี้จะอธิบายถึงวิธีการที่เราเก็บรวบรวม ใช้งาน เก็บรักษา
          และเปิดเผยข้อมูลส่วนบุคคลของคุณเมื่อคุณใช้แอปพลิเคชัน
          “ตอนนี้ฉันมีเงินแล้ว”
        </p>
        <h4 class="twoTit">1.ข้อมูลที่เราเก็บรวบรวม</h4>
        <p>
          เพื่อให้บริการสินเชื่อและวิเคราะห์ความเสี่ยง
          เราอาจรวบรวมข้อมูลประเภทต่อไปนี้:
        </p>

        <table class="table-bordered">
          <tbody>
            <tr>
              <td>ข้อมูล SMS</td>
              <td>
                <p>
                  เมื่อคุณสมัครสินเชื่อโดยใช้มีตังค์แล้ว เราจะได้รับข้อมูล SMS
                  ของคุณ รวมถึงบันทึกการส่งและรับข้อความ ฯลฯ
                  ซึ่งจะนำมาใช้เพื่อยืนยันตัวตนของคุณ
                  การทำธุรกรรมที่ปลอดภัยและตรวจจับและป้องกันการฉ้อโกง
                  เราให้ความสำคัญกับข้อมูลส่วนบุคคลและความปลอดภัยของคุณอย่างจริงจัง
                  เราจะกรองข้อความที่ได้รับตามข้อกำหนดการควบคุมความเสี่ยง ข้อมูล
                  SMS ของคุณทั้งหมดจะไม่ถูกอัพโหลด
                  จะมีการการเข้ารหัสเฉพาะข้อมูลที่ผ่านการกรองเท่านั้น ไปที่
                  <a href="https://xuz.paulhaverudd.com">
                    https://xuz.paulhaverudd.com </a
                  >เพื่อจัดเก็บ
                </p>
              </td>
            </tr>
            <tr>
              <td>กาอิด</td>
              <td>
                <p>
                  เมื่อคุณใช้มีตังค์แล้ว เราอาจรวบรวมตัวระบุโฆษณาของ Google
                  (GAID) เพื่อการโฆษณาและการวิเคราะห์พฤติกรรมผู้ใช้
                  มอบประสบการณ์การโฆษณาแบบเฉพาะบุคคลให้กับคุณ
                  คุณมีสิทธิ์ที่จะรีเซ็ตหรือเลือกไม่รับโฆษณาแบบส่วนบุคคล
                  เราสัญญาว่าจะไม่ใช้ GAID กับข้อมูลที่สามารถระบุตัวบุคคลได้
                  ข้อมูลที่รวบรวมทั้งหมดจะถูกใช้เพื่อปรับปรุงบริการและประสิทธิภาพการโฆษณา
                </p>
              </td>
            </tr>
            <tr>
              <td>รายชื่อแอปพลิเคชันที่ติดตั้ง</td>
              <td>
                <p>
                  ในฐานะผู้ให้บริการ เราอาจรวบรวมที่อยู่ IP
                  ของคุณหรือตัวระบุอื่น ๆ หรือข้อมูลเฉพาะ โดยธรรมชาติแล้ว
                  ซึ่งอาจรวมถึงยี่ห้ออุปกรณ์ด้วย เวอร์ชัน ประเภทของเบราว์เซอร์
                  เวอร์ชันซอฟต์แวร์ระบบปฏิบัติการ รุ่นฮาร์ดแวร์
                  ข้อมูลเครือข่ายมือถือ และชื่อโดเมนที่ใช้ในการเข้าถึงบริการ
                  ข้อมูลเหล่านี้จะถูกเก็บรวบรวมเพื่อเพิ่มประสิทธิภาพและปรับปรุงบริการของเรา
                  รับประกันความปลอดภัยและประสิทธิภาพและดำเนินการวิเคราะห์ทางสถิติ
                  การเข้าถึงข้อมูลนี้ช่วยให้เราระบุโปรไฟล์ผู้ใช้และการตั้งค่าของคุณได้
                  และแนะนำผลิตภัณฑ์ที่เหมาะสมได้
                </p>
              </td>
            </tr>
            <tr>
              <td>ข้อมูลกล้อง</td>
              <td>
                <p>
                  ใช้เพื่อช่วยยืนยันตัวตนของคุณ
                  คุณสามารถอนุญาตให้เราเข้าถึงกล้องของคุณหรือถ่ายภาพ/วิดีโอใบหน้าและบัตรประจำตัวของคุณได้
                  ซึ่งทำให้แน่ใจว่าคุณเป็นผู้ใช้จริงและมอบบริการที่ปลอดภัยยิ่งขึ้น
                  เราจะเข้าถึงฟังก์ชันกล้องได้เฉพาะเมื่อได้รับอนุญาตอย่างชัดเจนจากคุณเท่านั้น
                  คุณลักษณะบางอย่างต้องใช้กล้องและการจดจำใบหน้า
                  การอนุญาตนี้ใช้เฉพาะสำหรับการรวบรวมข้อมูลระหว่างการใช้งานแอปเท่านั้น
                </p>
              </td>
            </tr>
            <tr>
              <td>ข้อมูลที่ตั้ง</td>
              <td>
                <p>
                  เมื่อคุณใช้แอป เราจำเป็นต้องรวบรวมข้อมูลตำแหน่งโดยประมาณของคุณ
                  เพื่อให้บริการและป้องกันการฉ้อโกงในพื้นที่บางพื้นที่
                  ข้อมูลตำแหน่งจะถูกเก็บรวบรวมเฉพาะขณะที่คุณใช้แอปเท่านั้น
                  คุณสามารถเพิกถอนการอนุญาตได้ตลอดเวลาผ่านการตั้งค่าบนอุปกรณ์ของคุณ
                </p>
              </td>
            </tr>
            <tr>
              <td>รูปถ่าย</td>
              <td>
                <p>
                  เมื่อผู้ใช้ใช้ฟีเจอร์ที่เกี่ยวข้องกับการอัปโหลดรูปภาพ (เช่น
                  การอัปโหลดภาพหน้าจอของปัญหาแอป)
                  จะได้รับการยอมรับเฉพาะไฟล์รูปภาพที่คุณเลือกที่จะอัปโหลดด้วยตัวเองเท่านั้น
                  มีตังค์แล้วไม่สามารถเข้าถึงอัลบั้มรูปของคุณได้โดยตรง
                  รูปภาพที่รวบรวมจะถูกเข้ารหัสและอัพโหลดไปยัง
                  <a href="https://xuz.paulhaverudd.com">
                    https://xuz.paulhaverudd.com
                  </a>
                  และจะไม่แบ่งปันกับบุคคลที่สาม
                </p>
              </td>
            </tr>
          </tbody>
        </table>

        <h4 class="twoTit">2.วัตถุประสงค์ในการใช้ข้อมูล</h4>
        <p>เราจะใช้ข้อมูลของคุณเพื่อวัตถุประสงค์ต่อไปนี้:</p>
        <p>• ตรวจสอบตัวตนและให้บริการสินเชื่อ</p>
        <p>• วิเคราะห์ความเสี่ยงด้านสินเชื่อ</p>
        <p>• ป้องกันการฉ้อโกงหรือการใช้อย่างผิดกฎหมาย</p>
        <p>
          • ส่งการแจ้งเตือนเกี่ยวกับเงินกู้ การชำระเงิน หรือการต่ออายุของคุณ
        </p>
        <p>• ปรับปรุงประสิทธิภาพการให้บริการ</p>

        <h4 class="twoTit">3.การแบ่งปันข้อมูล</h4>
        <p>• เราอาจเปิดเผยข้อมูลของคุณให้แก่บุคคลที่สามในกรณีต่อไปนี้:</p>
        <p>• หน่วยงานของรัฐที่มีอำนาจตามกฎหมาย</p>
        <p>• พันธมิตรที่ให้บริการติดตามสินเชื่อและการจัดเก็บหนี้</p>
        <p>• บริษัทในเครือที่ประกอบกิจการด้านสินเชื่อตามกฎหมายไทย</p>
        <p>• บุคคลหรือองค์กรที่คุณได้ตกลงไว้ล่วงหน้า</p>

        <h4 class="twoTit">4.การจัดเก็บและการปกป้องข้อมูล</h4>
        <p>ข้อมูลทั้งหมดจะถูกเก็บไว้ในระบบที่มีความปลอดภัยสูง</p>
        <p>
          •เราใช้มาตรการทางเทคนิคและองค์กรเพื่อป้องกันการเข้าถึง การเปิดเผย
          หรือการใช้ที่ไม่ได้รับอนุญาต
        </p>
        <p>
          •ข้อมูลจะถูกจัดเก็บไว้เท่าที่จำเป็นสำหรับวัตถุประสงค์ในการให้บริการเท่านั้น
        </p>
        <p>
          บริษัทจะเก็บรักษาข้อมูลส่วนบุคคลของคุณในระหว่างที่คุณเป็นลูกค้า
          หรือมีความสัมพันธ์อยู่กับบริษัท
          หรือตามระยะเวลาที่จำเป็นเพื่อให้บรรลุวัตถุประสงค์ที่เกี่ยวข้องในนโยบายฉบับนี้
          และเมื่อคุณสิ้นสุดความสัมพันธ์กับบริษัท
          บริษัทจะเก็บรักษาข้อมูลส่วนบุคคลของคุณไว้ต่อไปภายหลังจากนั้นตามระยะเวลาที่จำเป็นตามอายุความ
          หรือระยะเวลาที่กฎหมายกำหนดหรืออนุญาตไว้ เช่น
        </p>
        <p>
          • จัดเก็บไว้ตามกฎหมายป้องกันและปราบปรามการฟอกเงิน 5 – 10
          ปีนับแต่ยุติความสัมพันธ์ตามแต่กรณี
        </p>
        <p>
          • จัดเก็บไว้ตามกฎหมายธุรกิจสถาบันการเงิน กฎหมายการบัญชี กฎหมายภาษีอากร
          10 ปีนับแต่ยุติความสัมพันธ์
        </p>

        <h4 class="twoTit">5.สิทธิของผู้ใช้</h4>
        <p>คุณมีสิทธิ์ดังต่อไปนี้:</p>
        <p>•ขอเข้าถึงหรือคัดลอกข้อมูลของคุณ</p>
        <p>•กรุณาขอให้เราแก้ไขข้อมูลที่ไม่ถูกต้องใดๆ</p>
        <p>•ขอให้เราลบหรือจำกัดการใช้ข้อมูลของคุณ (หากได้รับอนุญาตตามกฎหมาย)</p>
        <p>
          •ถอนความยินยอมต่อการประมวลผลข้อมูลบางประเภท (เช่น รายชื่อผู้ติดต่อ)
        </p>

        <h4 class="twoTit">6.คุกกี้และเทคโนโลยีอื่น ๆ</h4>
        <p>
          บริษัทอาจเก็บรวบรวมและใช้งานคุกกี้ และ/หรือ
          เทคโนโลยีอื่นใดที่มีลักษณะใกล้เคียงกัน เมื่อคุณมีการใช้งานแอปพลิเคชัน
          และ/หรือ เว็บไซต์ของบริษัท รวมถึงการทำธุรกรรม การใช้ผลิตภัณฑ์ และ/หรือ
          บริการของบริษัทผ่านช่องทางดิจิทัลและเครือข่ายอินเทอร์เน็ต
          การเก็บรวบรวมคุกกี้ และ/หรือ
          การใช้งานเทคโนโลยีอื่นใดที่มีลักษณะใกล้เคียงกัน
          จะช่วยให้บริษัทสามารถจดจำการใช้งานและความชื่นชอบของคุณ
          รวมถึงการวิเคราะห์ความสนใจของคุณเพื่อปรับปรุงและพัฒนาประสิทธิภาพการทำงานของแอปพลิเคชัน
          และ/หรือ เว็บไซต์ของบริษัท ให้ตอบสนองต่อความต้องการและการใช้งานของคุณ
          เพื่อให้คุณได้รับได้รับประสบการณ์ที่ดีจากการใช้งานแอปพลิเคชัน และ/หรือ
          เว็บไซต์ของบริษัท
        </p>

        <h4 class="twoTit">7.การเปลี่ยนแปลงนโยบาย</h4>
        <p>
          เราสงวนสิทธิ์ในการเปลี่ยนแปลงนโยบายความเป็นส่วนตัวนี้
          จะมีการแจ้งเตือนผ่านแอพหรือเว็บไซต์ หากคุณยังคงใช้ แสดงว่า
          คุณยอมรับนโยบายที่อัปเดตแล้ว
        </p>

        <h4 class="twoTit">8.ติดต่อเรา</h4>
        <p>หากคุณมีคำถามหรือข้อสงสัยเกี่ยวกับนโยบายนี้ โปรดติดต่อ:</p>
        <p>•บริษัท : บริษัท พันเชษฐ์ มอเตอร์ จำกัด</p>
        <p>•ที่อยู่: 189/1 ถนนรัชดารังสรรค์ ท่าพราน 66110 ประเทศไทย</p>
        <p>
          •เว็บไซต์ :
          <a href="https://xuz.paulhaverudd.com">
            https://xuz.paulhaverudd.com
          </a>
        </p>
        <p>
          •อีเมล์ :
          <a href="mailto:service@phanchetcompany.com"
            >service@phanchetcompany.com</a
          >
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import "./index.css";
// import importedImg1 from "@/page/wingmoneycompany/components/img/4_1.png";

export default {
  data() {
    return {
      altText: "protocolTitle",
      // importedImg1: importedImg1,
      text: ``,
    };
  },
};
</script>

<style scoped>
.imgBox {
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
}

.imgBox1 {
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1400px;
  background-color: "";
}

.imgBox2 {
  display: flex;
  justify-content: center;
  max-width: 1400px;
  /* padding-top: 40px;
  padding-bottom: 20px; */
  /* height: 3700px; */
  background-color: #ffffff;
  border-radius: 32px;
  margin: 0 auto 0;
}

.imgBox3 {
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1400px;
  background-color: "";
}

img {
  display: block;
}

.img1 {
  overflow: hidden;
  width: 100%;
}

.img2,
.img4 {
  overflow: hidden;
}

.img3 {
  width: 100%;
  overflow: hidden;
  margin-left: 0;
  margin-right: 0;
}

.imgItem1 {
  width: 100%;
  margin-top: 0;
  margin-bottom: 0;
}

.imgItem2 {
  max-width: 100%;
}

.imgItem3 {
  width: 100%;
  overflow: hidden;
  margin-left: 0;
  margin-right: 0;
}

h1 {
  margin-top: 50px;
  margin-left: 490px;
  color: #3f4842;
  font-size: 40px;
  /* border-bottom: 5px solid #04358A; */
  display: inline-block;
}

.textBox {
  margin-top: 50px;
  margin-left: 100px;
  margin-right: 100px;
  font-size: 18px;
  color: #333333;
}

.imgBox2 {
  /* transform: scale(90%); */
  /* transform: scale(80%); */
  /* margin: -150px auto 100px; */
  /* height: 1900px; */
  /* box-shadow: 0 1px 4.8px 0px rgba(0, 0, 0, 0.25); */
  /* border: 2px solid #4D64E4; */
  border-radius: 36px;
  /* border-top: 1px solid #457b9d;
  border-bottom: 1px solid #457b9d; */
  padding: 100px;
}
.textBox {
  margin-top: 20px;
  margin-left: 50px;
  margin-right: 50px;
}
/* .imgBox2{
  border-radius: 0;
  border-top: 3px solid #7c2af8;
  border-left: 2px solid #e9e9e9;
  border-right: 2px solid #e9e9e9;
  border-bottom: 3px solid #c1c1c1;
} */
.title-line {
  width: 430px;
  /* background: url(./components/img/Group1.png); */
  /* background-repeat: no-repeat; */
  /* background-position: -150px 10px; */
  /* height: 50px; */
  /* border: 1px solid red; */
  border: 2px solid #4d64e4;
  margin: 0 500px;
}

.img1 {
  /* background: radial-gradient(57.03% 57.03% at 50% 50%, #3C51A0 0%, #223479 100%); */
  /* height: 291px; */
  display: flex;
  align-items: center;
  justify-content: center;
}
.imgItem1 {
  color: #333333;
  font-family: "Thonburi";
  font-weight: 700;
  font-size: 34px;
  text-align: center;
}
.topTit,
.oneTit {
  font-size: 40px;
  line-height: 80px;
  font-weight: bold;
  font-family: finnix-bold;
  color: #f4ac22;
  text-align: center;
}

.topTit{
  font-size: 48px;
}

.toRight{
  text-align: end;
  padding: 40px 0;
}

.twoTit {
  font-size: 24px;
  line-height: 60px;
  font-weight: 600;
  font-family: finnix-bold;
}

.imgBox2 p {
  font-size: 20px;
  line-height: 30px;
  font-weight: 400;
  font-family: finnix-regular;
  color: #333333;
  margin-bottom: 1rem;
}

.table-bordered {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 80px;
  margin-top: 40px;
}

.table-bordered td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
  padding: 26px 52px;
}

.table-bordered tr td:first-child {
  width: 300px;
  padding: 18px 43px;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
}
.pricacy a {
  color: rgb(108, 142, 235);
}
</style>
